import {AfterViewInit, Component, ElementRef, Input, Renderer2} from '@angular/core';
import {UIArtefakt} from '../../models/uiArtefakt';

@Component({
    selector: 'lv-platzhalter',
    templateUrl: './platzhalter.component.html',
    styleUrls: ['./platzhalter.component.scss'],
    standalone: false
})
export class PlatzhalterComponent implements AfterViewInit{
  private _uiArtefakt: UIArtefakt;

  constructor(private _renderer: Renderer2, private _element: ElementRef) {
  }

  get uiArtefakt(): UIArtefakt {
    return this._uiArtefakt;
  }

  @Input()
  set uiArtefakt(uiArtefakt: UIArtefakt) {
    this._uiArtefakt = uiArtefakt;
  }

  ngAfterViewInit(): void {
    this._renderer.setAttribute(this._element.nativeElement, 'cypress-uuid', this.uiArtefakt.IdentifikatorUuid);
  }
}
